import React, { useState } from 'react';

import { useTranslation } from 'react-i18next';

import SearchBar from '../../../../../shared/components/SearchBarNE/SearchBarNE';
import StyledButtonNE from '../../../../../shared/components/StyledButtonNE/StyledButtonNE';
import StyledMenu from '../../../../../shared/components/StyledMenu/StyledMenu';
import StyledTabBar from '../../../../../shared/components/StyledTabBar/StyledTabBar';
import { FILTER_IMAGES, REFRESH_IMAGE } from '../../../../../shared/constants/images';
import { REWARDS_ORDER_HISTORY_TYPE_TABS, REWARDS_ORDER_STATUS_FILTER } from '../../../../../shared/constants/rewards';
import {
  CLICK_ACTION,
  ORDER_HISTORY_FILTER_DROPDOWN,
  ORDER_HISTORY_RELOAD,
  REWARDS_HISTORY_SECTION
} from '../../../../../shared/constants/tagManager';
import { IRewardsOrderFilter, IRewardsOrderFilters } from '../../../../../shared/interfaces/rewards';
import TagManagerService from '../../../../../shared/services/gtm/tagManagerService';
import { TRANSLATION_HISTORY } from '../../../../../shared/translations/rewards';
import { RewardsOrderTypesEnum } from '../../../../../shared/types/rewards';

interface RewardsHistoryFilterProps {
  loading: boolean;
  ordersFilters: IRewardsOrderFilters;
  changeRewardsOrdersFilters: (storiesFilters: IRewardsOrderFilters) => void;
}

const RewardsHistoryFilter = ({ loading, ordersFilters, changeRewardsOrdersFilters }: RewardsHistoryFilterProps) => {
  const [selectedTab, setSelectedTab] = useState<RewardsOrderTypesEnum>(RewardsOrderTypesEnum.outgoings);

  const [anchorEl, setAnchorEl] = useState(null);
  const { t } = useTranslation();

  const changeTab = (newTab: number) => {
    setSelectedTab(newTab);
    const option = REWARDS_ORDER_HISTORY_TYPE_TABS[newTab];
    TagManagerService.pushEvent(CLICK_ACTION, REWARDS_HISTORY_SECTION, option.gtmTag);
    changeRewardsOrdersFilters({ status: REWARDS_ORDER_STATUS_FILTER.all, type: option, searchValue: '' });
  };

  const changeStatusFilter = (filterOption: IRewardsOrderFilter) => {
    changeRewardsOrdersFilters({ ...ordersFilters, status: filterOption });
    handleClose();
    TagManagerService.pushEvent(CLICK_ACTION, ORDER_HISTORY_FILTER_DROPDOWN, {
      ...filterOption.gtmTag,
      ...ordersFilters.type.gtmTag
    });
  };

  const onSearch = (searchValue: string) => {
    changeRewardsOrdersFilters({ ...ordersFilters, searchValue: searchValue });
  };

  const handleRefreshButtonClick = () => {
    changeRewardsOrdersFilters({ ...ordersFilters });
    TagManagerService.pushEvent(CLICK_ACTION, ORDER_HISTORY_RELOAD);
  };

  const handleButtonClick = async (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const filtersMenu = [
    [
      {
        label: t(REWARDS_ORDER_STATUS_FILTER.all.filter),
        action: () => changeStatusFilter(REWARDS_ORDER_STATUS_FILTER.all)
      },
      {
        label: t(REWARDS_ORDER_STATUS_FILTER.sent.filter),
        action: () => changeStatusFilter(REWARDS_ORDER_STATUS_FILTER.sent)
      },
      {
        label: t(REWARDS_ORDER_STATUS_FILTER.failed.filter),
        action: () => changeStatusFilter(REWARDS_ORDER_STATUS_FILTER.failed)
      }
    ],
    [
      {
        label: t(REWARDS_ORDER_STATUS_FILTER.all.filter),
        action: () => changeStatusFilter(REWARDS_ORDER_STATUS_FILTER.all)
      },
      {
        label: t(REWARDS_ORDER_STATUS_FILTER.approved.filter),
        action: () => changeStatusFilter(REWARDS_ORDER_STATUS_FILTER.approved)
      },
      {
        label: t(REWARDS_ORDER_STATUS_FILTER.inProgress.filter),
        action: () => changeStatusFilter(REWARDS_ORDER_STATUS_FILTER.inProgress)
      },
      {
        label: t(REWARDS_ORDER_STATUS_FILTER.rejected.filter),
        action: () => changeStatusFilter(REWARDS_ORDER_STATUS_FILTER.rejected)
      }
    ]
  ];

  return (
    <>
      <StyledTabBar
        items={REWARDS_ORDER_HISTORY_TYPE_TABS.map((tab) => t(tab.label))}
        action={changeTab}
        activeIndex={selectedTab}
      />

      <div className="flex flex-row gap-6 justify-between items-center">
        <SearchBar onSearch={onSearch} placeholder={t(TRANSLATION_HISTORY.table.searchPlaceholder)} />
        <div className="flex flex-row gap-4 justify-between whitespace-nowrap">
          <StyledButtonNE
            loading={loading}
            disabled={loading}
            buttonType="secondary"
            buttonSize="sm"
            action={handleRefreshButtonClick}
            image={REFRESH_IMAGE}
          >
            {t(TRANSLATION_HISTORY.table.refresh)}
          </StyledButtonNE>
          <StyledButtonNE
            loading={loading}
            disabled={loading}
            buttonType="secondary"
            buttonSize="sm"
            action={handleButtonClick}
            image={FILTER_IMAGES}
          >
            {t(ordersFilters.status.filter)}
          </StyledButtonNE>
          <StyledMenu
            anchorEl={anchorEl}
            handleClose={handleClose}
            menuItems={filtersMenu[selectedTab]}
            anchorOrigin={undefined}
            transformOrigin={undefined}
          />
        </div>
      </div>
    </>
  );
};

export default RewardsHistoryFilter;
